import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as LoginActions from "./redux/login/loginActions";

const Authenticate = (props) => {
    // once we load authenticate with keycloak
    useEffect(() => {
        if (!props.login.authenticated) {
            props.authenticate();
        }
    }, []);

    return props.login.authenticated ? (
        <>
            {props.login.keycloak.hasRealmRole("ContractorAdminRole") && props.adminRoutes}
            {props.login.keycloak.hasRealmRole("ContractorLabourerRole") && props.labourerRoutes}
        </>
    ) : null;

    // return <> {props.adminRoutes} </>
};

function mapStateToProps(state) {
    return {
        login: state.login,
    };
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            authenticate: LoginActions.requestLogin,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(Authenticate);
